// extracted by mini-css-extract-plugin
module.exports = {"lakat":"poll-config_lakat__2bQWJ","form":"poll-config_form__2W1Vg"};